/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Information } from '@carbon/react/icons';
import { TooltipIcon } from 'carbon-components-react';
import _ from 'lodash';
import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import { SelectEventsMessages as eventMessages } from '../select-events-tab/messages';
import { ReviewAndConfirmMessages as messages } from './messages';
import { ReviewConfirmContent } from './ReviewConfirmContent';

import './ReviewConfirmTab.scss';

interface ReviewConfirmProps {
  isLive: boolean;
  envName: string;
}
export const ReviewConfirm = ({ isLive, envName }: ReviewConfirmProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <div className="ReviewAndConfirm">
      <div className="QuickSetup__step-title">
        <FormattedMessage {...messages.title} />
      </div>
      <div className="TabContent__spacer8" />
      <div className="TabContent__subtitle">
        <FormattedMessage {...messages.description} />
      </div>
      <div className="TabContent__spacer8" />
      <div className="ReviewAndConfirm__environment">
        <div className="ReviewAndConfirm__environment-title">
          <FormattedMessage {...messages.environment} />
          <TooltipIcon
            className="ReviewAndConfirm__info-icon"
            direction="top"
            tooltipText={t(messages.tooltip)}>
            <Information size={16} />
          </TooltipIcon>
        </div>
        <div className="ReviewAndConfirm__environment-name">
          {t(messages.environmentName, {
            envName: _.capitalize(envName)
          })}
        </div>
      </div>
      <div className="ReviewAndConfirm__table-header">
        <div className="ReviewAndConfirm__table-title">
          <FormattedMessage {...messages.eventSent} />
        </div>
        <div className="ReviewAndConfirm__table-description">
          <FormattedMessage
            {...eventMessages.selectEventsDescription}
            values={{ env: isLive ? 'Live' : 'Draft' }}
          />
        </div>
      </div>
      <ReviewConfirmContent />
    </div>
  );
};
